import React, { useState } from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

const Header = () => {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  return (
    <header>
      <nav className="navigation">
        <Link to="/" className="brand-name">
          <StaticImage
            className="logo-image"
            layout="constrained"
            formats={['auto', 'webp', 'avif']}
            src="../../images/logo.png"
            alt="Logo"
            placeholder="blurred"
          />
        </Link>
        <button
          className="hamburger"
          onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="white">
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div className={isNavExpanded ? 'navigation-menu expanded' : 'navigation-menu'}>
          <ul>
            <li className="subnav">
              <span
                onClick={() => {
                  return;
                }}>
                Про нас
              </span>
              <ul className="subnav-content">
                <li className="subnav-content__item">
                  <Link to="/history-of-the-institution">Історія закладу</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/schedule">Режим роботи</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/administration">Адміністрація</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/team">Колектив</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/our-achievements">Наші досягнення</Link>
                </li>
              </ul>
            </li>
            <li className="subnav">
              <span
                onClick={() => {
                  return;
                }}>
                Для батьків
              </span>
              <ul className="subnav-content">
                <li className="subnav-content__item">
                  <Link to="/groups">Групи</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/consultations-for-parents">Консультації для батьків</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/bullying">Булінг</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/group-work">Гурткова робота</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/learning-with-lego">Навчання разом з LEGO</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/music-and-physical-education-of-preschoolers">
                    Сторінка музичного та фізичного виховання ЗДО
                  </Link>
                </li>
              </ul>
            </li>
            <li className="subnav">
              <Link to="/daily-menu">Харчування в ЗДО</Link>
            </li>
            <li className="subnav">
              <span
                onClick={() => {
                  return;
                }}>
                Новини
              </span>
              <ul className="subnav-content">
                <li className="subnav-content__item">
                  <Link to="/news">Новинки цікавинки</Link>
                </li>
                <li className="subnav-content__item">
                  <Link to="/">Архів новин</Link>
                </li>
              </ul>
            </li>
            <li className="subnav">
              <Link to="/gallery">Фотогалерея</Link>
            </li>
            <li className="subnav">
              <a
                href="https://2021.vmr.gov.ua/TransparentCity/dnz/Lists/Content/ShowContent.aspx?ID=17"
                target="_blank"
                rel="noopener noreferrer">
                Реєстрація до ЗДО
              </a>
            </li>
            <li className="subnav">
              <Link to="/contact-us">Зворотній зв&apos;язок</Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
